import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';

// replaced by webpack.DefinePlugin
declare const __IS_PRODUCTION__: boolean;

if (__IS_PRODUCTION__) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch(err => console.error(err)); // eslint-disable-line no-console
